"use strict";

var _extends = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var a in r) {
      Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
  }

  return e;
},
    _createClass = function () {
  function a(e, t) {
    for (var r = 0; r < t.length; r++) {
      var a = t[r];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }

  return function (e, t, r) {
    return t && a(e.prototype, t), r && a(e, r), e;
  };
}();

function _objectWithoutProperties(e, t) {
  var r = {};

  for (var a in e) {
    0 <= t.indexOf(a) || Object.prototype.hasOwnProperty.call(e, a) && (r[a] = e[a]);
  }

  return r;
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    TextArea = function () {
  function r(e) {
    _classCallCheck(this, r);

    var t = _possibleConstructorReturn(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));

    return t.textAreaRef = React.createRef(), t;
  }

  return _inherits(r, React.Component), _createClass(r, [{
    key: "componentDidMount",
    value: function value() {
      this.resizeTextArea();
    }
  }, {
    key: "resizeTextArea",
    value: function value() {
      this.textAreaRef && (this.textAreaRef.current.style.height = "1px", this.textAreaRef.current.style.height = this.textAreaRef.current.scrollHeight + "px");
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          e = this.props,
          r = e.isValid,
          a = e.invalidErrorMessage,
          s = e.label,
          n = e.style,
          o = e.className,
          l = e.onKeyUp,
          i = _objectWithoutProperties(e, ["isValid", "invalidErrorMessage", "label", "style", "className", "onKeyUp"]),
          c = null;

      r || (c = React.createElement("span", {
        className: "blx-invalid-input-message"
      }, a));
      var p = null;
      s && (p = React.createElement("label", {
        className: "blx-ui-text"
      }, s));
      var u = classnames("blx-text-field", o, {
        "blx-disabled": i.disabled
      }),
          f = classnames({
        "blx-invalid": !r
      });
      return React.createElement("div", {
        style: n,
        className: u
      }, p, React.createElement("div", {
        className: "blx-text-field-container"
      }, React.createElement("textarea", _extends({
        className: f,
        ref: this.textAreaRef,
        onKeyUp: function onKeyUp(e) {
          l && l(e), t.resizeTextArea();
        }
      }, i))), c);
    }
  }]), r;
}();

TextArea.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isValid: PropTypes.bool,
  invalidErrorMessage: PropTypes.string,
  onKeyUp: PropTypes.func
}, TextArea.defaultProps = {
  className: "",
  style: null,
  label: "",
  disabled: !1,
  isValid: !0,
  invalidErrorMessage: "",
  onKeyUp: null
}, module.exports = TextArea;